import {
  Box,
  Button,
  Divider,
  Heading,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { Formik, FormikProps, Form } from 'formik';
import React from 'react';

import 'source/packages/logged-out/home.scss';

import { LoginFormValues } from 'types/dashboard.d';

import { colors } from 'packages/common-frontend/colors';
import {
  InputFormField,
  FormSubmitButton,
} from 'packages/common-frontend/components/FormField';
import { isCustomerDashboard } from 'packages/common-frontend/utils';
import { useLoginFormManagement } from 'packages/logged-out/hooks/useLoginFormManagement';
import { Auth0LoginButton } from 'packages/logged-out/ui/Auth0LoginButton';

type LoginFormProps = { onSubmit?: () => void };
export const LoginForm = ({ onSubmit }: LoginFormProps) => {
  const {
    initialValues,
    handleSubmit,
    formValidation,
  } = useLoginFormManagement();

  const isCustomerDash = isCustomerDashboard();

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box
      my={4}
      textAlign="center"
      width="100%"
      minHeight="240px"
      position="relative"
      padding={['0 20px', '0 20px', '0 20px', '0 20px']}
    >
      <Modal closeOnEsc isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Forgot password?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Contact your Customer Service Manager via{' '}
              <Link href="mailto:support@finleycms.com" color="blue.400">
                email
              </Link>{' '}
              to update your password.
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button
              variant="solid"
              bgColor={colors.aurora['400']}
              color="white"
              onClick={onClose}
              mr={0}
            >
              Done
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Heading as="h4" size="md" textAlign="left" marginBottom="30px">
        Sign In
      </Heading>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) => {
          await handleSubmit(values);
          onSubmit?.();
        }}
        validationSchema={formValidation}
      >
        {(formProps: FormikProps<LoginFormValues>) => {
          return (
            <Form
              onSubmit={formProps.handleSubmit}
              style={{
                margin: 0,
                width: '100%',
              }}
            >
              <InputFormField
                isRequired
                propName="email"
                type="email"
                formProps={formProps}
                marginTop={6}
                label="Email"
                placeholder="Email Address"
                inputWidth="lg"
              />
              <InputFormField
                isRequired
                propName="password"
                type="password"
                label="Password"
                placeholder="Password"
                inputWidth="lg"
                formProps={formProps}
                marginTop={6}
              />
              <FormSubmitButton
                isSubmitting={formProps.isSubmitting}
                width="full"
              >
                Sign in to Finley
              </FormSubmitButton>
            </Form>
          );
        }}
      </Formik>
      {isCustomerDash && (
        <HStack pt={4}>
          <Spacer />
          <Button
            fontWeight="light"
            fontSize="sm"
            variant="link"
            color="gray"
            onClick={onOpen}
          >
            Forgot password?
          </Button>
        </HStack>
      )}
      {isCustomerDash && (
        <>
          <HStack width="full" pt={8} pb={4}>
            <Divider />
            <Text px={1}>or</Text>
            <Divider />
          </HStack>
          <Auth0LoginButton />
        </>
      )}
    </Box>
  );
};
